import React from "react";
import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/PublicLayout";

export default function Parents() {
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>Parents &amp; educators</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink max-w-4xl">Add excellence to your child's day.</h1>
      <p className="mt-6 max-w-2xl text-ink/70 text-lg leading-relaxed">Whether Simo becomes your child's primary school (full-time) or complements a traditional school (part-time accelerated), progression is determined by mastery. Parents hold the family account; each child has their own application and assessment record.</p>
      <div className="mt-12 grid md:grid-cols-2 gap-px bg-border border border-border">
        {[["Full-time pathway", "Simo as the primary educational provider, with structured live teaching and an individual pathway. Families handle jurisdiction-specific legal and home-education compliance.", "/programmes/k12-full-time"],
          ["Part-time accelerated", "Keep your child in their current school while building deeper conceptual understanding — traditional school becomes easier as mastery develops.", "/programmes/k12-part-time"]].map(([t, d, to]) => (
          <Link key={to} to={to} className="bg-paper p-8 hover:bg-secondary transition-colors">
            <div className="font-serif text-2xl text-ink">{t}</div>
            <p className="mt-3 text-ink/65 leading-relaxed">{d}</p>
            <span className="mt-4 inline-block text-heraldic">Learn more →</span>
          </Link>
        ))}
      </div>
    </Section>
  );
}
